// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tc-done-btn {
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  border-radius: 8px;
  height: 32px;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

ion-content {
  --background: #f5f8f6;
}

ion-item {
  --background: #fff;
  --border-style: none;
  border: 1px solid #e4ece7;
  border-radius: 14px;
  margin: 12px;
  box-shadow: 0 8px 20px rgba(16, 58, 41, 0.06);
}

ion-item p {
  margin: 0;
  font-size: 14px;
  color: #25362d;
  line-height: 1.65;
}

h4 {
  color: #1f2f26;
  margin-top: 14px;
  margin-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/terms-and-conditions/terms-and-conditions.page.scss"],"names":[],"mappings":"AAAA;EACE,2CAAA;EACA,qCAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,6CAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AACF","sourcesContent":[".tc-done-btn {\r\n  border: 1px solid rgba(255, 255, 255, 0.24);\r\n  background: rgba(255, 255, 255, 0.14);\r\n  color: #fff;\r\n  border-radius: 8px;\r\n  height: 32px;\r\n  padding: 0 12px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\nion-content {\r\n  --background: #f5f8f6;\r\n}\r\n\r\nion-item {\r\n  --background: #fff;\r\n  --border-style: none;\r\n  border: 1px solid #e4ece7;\r\n  border-radius: 14px;\r\n  margin: 12px;\r\n  box-shadow: 0 8px 20px rgba(16, 58, 41, 0.06);\r\n}\r\n\r\nion-item p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: #25362d;\r\n  line-height: 1.65;\r\n}\r\n\r\nh4 {\r\n  color: #1f2f26;\r\n  margin-top: 14px;\r\n  margin-bottom: 2px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
